module.exports = "https://www.gc-qa.gnp.com.mx/f5fba13a5e547189bddc57027f16246e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/close_green.svg
// module id = 1809
// module chunks = 0